<!--suppress HtmlUnknownBooleanAttribute -->
<template>
  <div v-if="isStartUpLoaded"
       class="foglaljpalyat-app">
    <!-- menu view -->
    <div class="row collapse expanded">
      <!-- global mode menu -->
      <div v-if="isGlobalMode"
           :class="{demo:isDemo}"
           class="small-12 columns">
        <a>Link</a>
        <logged-in-menu
          v-if="isLoggedIn()"
          :is-mobile-device="isMobileDevice"
          :user="user"
          @logout="logMeOut"
          @get-user-reservations="getUserReservations"
          @get-guest-passes="fetchPasses"
          @open-all-in-one-modal="openAllInOneModal"
        />
        <logged-out-menu
          v-else
          :facebook-login-url="facebookLoginUrl"
          :google-login-url="googleLoginUrl"
          :is-mobile-device="isMobileDevice"
        />
        <!--
        <div class="ui section divider"></div>
        -->
      </div>
      <div v-if="!isGlobalMode"
           class="small-12 columns">
        <local-menu
          :is-logged-in="isLoggedIn()"
          :is-mobile-device="isMobileDevice"
          @logout="logMeOut"
          @open-all-in-one-modal="openAllInOneModal"
        />
      </div>
      <!-- ./global mode menu -->
      <!-- header -->
      <header-box
        v-if="!isMobileDevice && isGlobalMode"
        :is-logged-in="isLoggedIn()"
        :is-mobile-device="isMobileDevice"
      />
      <div v-if="!isMobileDevice && isGlobalMode"
           class="header-space"></div>
      <div
        v-if="isMobileDevice && isGlobalMode"
        class="header-space-mobile"
      ></div>
      <!-- ./header -->
      <!-- client marked map -->
      <!--
      <google-marked-map/>
      -->
      <!-- ./client marked map -->
      <!-- how it works -->

      <!-- ./how it works -->
    </div>
    <!-- ./menu view -->
    <!-- main view -->
    <!-- clients -->
    <div class="row expanded">
      <div v-if="isGlobalMode"
           class="small-12 columns">
        <client-menu
          :is-logged-in="isLoggedIn()"
          :is-mobile-device="isMobileDevice"
          @insert-favorite-client="insertFavoriteClient"
          @change-favorite-client="changeFavoriteClient"
          @delete-favorite-client="deleteFavoriteClient"
          @fetch-free-clients-at-this-datetime="fetchFreeClientsAtThisDatetime"
          @create-new-reservation="createNewReservation"
          @resign-reservation="resignReservation"
        />
      </div>
      <div id="table-scroll-helper"></div>
      <div
        v-show="isClientSelected"
        id="schedule-table-default-place"
        class="small-12 columns"
      ></div>
      <div v-if="!isGlobalMode"
           class="width-100">
        <local-schedule-table-container
          :is-logged-in="isLoggedIn()"
          :is-mobile-device="isMobileDevice"
          :tables="this.$store.state.tables"
          @create-new-reservation="createNewReservation"
          @resign-reservation="resignReservation"
        />
      </div>
    </div>
    <!-- ./clients -->
    <!-- footer -->
    <footer-box v-if="isGlobalMode"
                :is-mobile-device="isMobileDevice"/>
    <!-- ./footer -->
    <!-- ./main view -->
    <!-- modal(s) -->
    <sign-up-modal @sign-up="signUp"/>
    <log-in-modal
      :is-logged-in="isLoggedIn()"
      @login="logMeIn"
      @forgotten-password-request="forgottenPasswordRequest"
    />
    <profile-modal
      v-if="user && user.name"
      :email="user.email"
      :is-google-calendar="user.isGoogleCalendar"
      :name="user.name"
      :phone="user.phone"
      @changeEmail="changeEmail"
      @saveUserModifications="saveUserModifications"
    />
    <profile-all-in-one-modal
      v-if="user && user.name"
      :email="user.email"
      :is-google-calendar="user.isGoogleCalendar"
      :is-user-reservations-loaded="isUserReservationsLoaded"
      :name="user.name"
      :passes="guestPasses"
      :phone="user.phone"
      @changeAddress="changeAddress"
      @changeEmail="changeEmail"
      @saveUserModifications="saveUserModifications"
      @updatePhoneNumber="updatePhoneNumber"
    />
    <reservation-modal
      v-if="isUserReservationsLoaded"
      :user-reservations="userReservations"
      @get-user-reservations="getUserReservations"
    />
    <pay-negative-balance-modal v-if="user && user.name"
                                @pay="pay"/>
    <passes-modal :passes="guestPasses"/>
    <partner-finder-profile-modal/>
    <!-- ./modal(s) -->

  </div>
</template>

<script>
/* eslint-disable no-prototype-builtins,vue/no-unused-components */

import GuestSchedule from '../schedule/GuestSchedule.vue';
import LoggedInMenu from '../menu/LoggedInMenu.vue';
import LoggedOutMenu from '../menu/LoggedOutMenu.vue';
import SignUpModal from '../modal/SingUpModal.vue';
import LogInModal from '../modal/LogInModal.vue';
import ProfileModal from '../modal/ProfileModal.vue';
import ReservationModal from '../modal/ReservationModal.vue';
import PassesModal from '../modal/PassesModal.vue';
import ProfileAllInOneModal from '../modal/ProfileAllInOneModal.vue';
import PartnerFinderProfileModal from '../partnerFinder/PartnerFinderProfileModal.vue';
import ClientMenu from '../client/ClientMenu';
import ScheduleTableContainer from '../schedule/ScheduleTableContainer';
import PayNegativeBalanceModal from '@/components/modal/PayNegativeBalanceModal';
import GoogleMarkedMap from '../map/GoogleMarkedMap';
import FooterBox from '../footer/FooterBox';
import HeaderBox from '../header/HeaderBox';
import LocalScheduleTableContainer from '@/components/schedule/LocalScheduleTableContainer';
import LocalMenu from '@/components/menu/LocalMenu';
import sha1 from 'js-sha1';
// import MobileDetect from "mobile-detect";
import config from '@/config';
import utils, {logMeIn} from '@/utils';
// eslint-disable-next-line
import notify from '../../notify';
/* eslint-disabled */
import moment from 'moment';
import {processTableStatus} from '@/store';

export default {
  data () {
    return {
      serverDomain: config.SERVER_DOMAIN,
      googleLoginUrl: config.GOOGLE_LOGIN_URL,
      facebookLoginUrl: config.FACEBOOK_LOGIN_URL,
      subjectTypes: [],
      globalSubjectTypes: [],
      tables: [],
      tableDate: moment().format('YYYY-MM-DD'),
      currentSubjectTypeID: null,
      currentGlobalSubjectTypeID: null,
      userReservations: [],
      guestPasses: [],
      cssApplied: false,
    };
  },
  methods: {
    showState () {
      alert(this.isLoggedIn());
    },
    fetchSubjectTypes (domain) {
      return new Promise((resolve, reject) => {
        this.$http({
          url: this.serverDomain + '/api/global/subjecttypes',
          method: 'GET',
          params: { domain: domain },
        }).then(
          (response) => {
            resolve(response.body);
          },
          (error) => {
            utils.httpError(error);
            reject();
          },
        );
      });
    },
    decreaseCurrentDay () {
      let currentTableDate = this.$store.state.currentTableDate;
      let newTableDate = moment(currentTableDate)
        .subtract(1, 'day')
        .format('YYYY-MM-DD');

      console.log(currentTableDate);
      console.log(newTableDate);

      this.tableDate = newTableDate;
    },
    increaseCurrentDay () {
      let currentTableDate = this.tableDate;
      let newTableDate = moment(currentTableDate)
        .add(1, 'day')
        .format('YYYY-MM-DD');

      console.log(currentTableDate);
      console.log(newTableDate);

      this.tableDate = newTableDate;
    },
    fetchPasses (isAllInOne) {
      this.$http({
        url: this.serverDomain + '/api/global/passes',
        method: 'GET',
        params: {
          ...this.$store.getters.getAuthParams,
          email: this.$store.state.user.email,
        },
      }).then(
        (response) => {
          console.log('--- get guest passes success');
          console.log(response.body);
          this.guestPasses = response.body;
          if (isAllInOne) {
            this.getUserReservations(true);
          } else {
            // eslint-disable-next-line
            this.$modal.show('passes-modal');
          }
        },
        (error) => {
          utils.httpError(error);
        },
      );
    },
    resignReservation (timeTableID) {
      let self = this;
      const isGlobalMode = !!this.isGlobalMode;
      this.$http({
        url: this.isGlobalMode
          ? this.serverDomain + '/api/global/resigncheck'
          : this.serverDomain + '/api/guest/resigncheck',
        method: 'DELETE',
        params: {
          ...this.$store.getters.getAuthParams,
        },
        body: JSON.stringify({
          data: {
            timeTableID: timeTableID,
            domain: this.$store.state.currentClientDomain,
            email: this.$store.state.user.email,
          },
        }),
      }).then(
        (response) => {
          console.log('--- resign check success');
          if (response.body.willBeCharged) {
            notify.confirmation(response.body.msg).then(
              () => {
                resign();
              },
              () => {
              },
            );
          } else {
            resign();
          }
          console.log(response.body);
        },
        (error) => {
          utils.httpError(error);
        },
      );

      function resign () {
        self
          .$http({
            url: isGlobalMode
              ? self.serverDomain + '/api/global/resign'
              : self.serverDomain + '/api/guest/resign',
            method: 'DELETE',
            params: {
              ...self.$store.getters.getAuthParams,
            },
            body: JSON.stringify({
              data: {
                timeTableID: timeTableID,
                domain: self.$store.state.currentClientDomain,
                email: self.$store.state.user.email,
              },
            }),
          })
          .then(
            (response) => {
              console.log('--- resign success');
              notify.success(response.body.msg);
            },
            (error) => {
              utils.httpError(error);
            },
          );
      }
    },
    signUp (userData) {
      console.log('--- sign me up: ');
      console.log(userData);
      this.$http({
        url: this.serverDomain + '/api/guest/signup',
        method: 'POST',
        params: {
          ...this.$store.getters.getAuthParams,
        },
        body: JSON.stringify({ data: userData }),
      }).then(
        (/*response*/) => {
          console.log('--- registration success');
          this.$modal.hide('sign-up-modal');
          notify.success(
            'Sikeres regisztráció. Email-cím megerősítő levelét elküldtük a megadott címre',
          );
        },
        (error) => {
          utils.httpError(error);
        },
      );
    },
    saveUserModifications (userData) {
      console.log('--- modify guest data: ');
      console.log(userData);
      this.$http({
        url: this.serverDomain + '/api/guest/details',
        method: 'PUT',
        params: {
          ...this.$store.getters.getAuthParams,
        },
        body: JSON.stringify({ data: userData }),
      }).then(
        (/*response*/) => {
          this.$modal.hide('profile-modal');
          notify.success('Profil sikeresen mentve');
        },
        (error) => {
          utils.httpError(error);
        },
      );
    },
    updatePhoneNumber (newPhoneNumber) {
      console.log('--- modify guest phone number: ');
      console.log(newPhoneNumber);
      let updateData = {
        // eslint-disable-next-line no-prototype-builtins
        email: this.$store.state.user.hasOwnProperty('email')
          ? this.$store.state.user.email
          : null,
        phone: newPhoneNumber,
      };
      if (updateData.email) {
        this.$http({
          url: this.serverDomain + '/api/global/change_phone_number',
          method: 'PUT',
          params: {
            ...this.$store.getters.getAuthParams,
          },
          body: JSON.stringify({ data: updateData }),
        }).then(
          (/*response*/) => {
            // this.$modal.hide('profile-modal')
            notify.success('Telefonszám módosítása sikeres');
            this.$store.dispatch('setUserPhoneNumber', {
              newPhoneNumber: newPhoneNumber,
            });
            this.$modal.hide('change-phone-number-modal');
          },
          (error) => {
            utils.httpError(error);
          },
        );
      }
    },
    logMeOut () {
      this.$http({
        url: this.serverDomain + '/api/auth/logout',
        method: 'DELETE',
        params: {
          ...this.$store.getters.getAuthParams,
        },
      });
      utils.deleteCookie('userID', this.$store.state.isGlobalMode);
      utils.deleteCookie('token', this.$store.state.isGlobalMode);
      utils.deleteCookie('isDigital', this.$store.state.isGlobalMode);
      location.reload();
    },
    logMeIn (data) {
      let email = data.email;
      let pwd = sha1(data.pwd);
      this.$http({
        url: this.serverDomain + '/api/auth/guest',
        method: 'POST',
        body: JSON.stringify({ email: email, password: pwd }),
      })
        .then(
          (response) => {
            let userID = response.body.userID;
            let token = response.body.token;
            const isDigital = response.body.userType === 'digital'
            logMeIn(userID, token, isDigital)
            // utils.setCookie(
            //     "userID",
            //     userID,
            //     300,
            //     this.$store.state.isGlobalMode
            // );
            // utils.setCookie(
            //     "token",
            //     token,
            //     300,
            //     this.$store.state.isGlobalMode
            // );
            // utils.setCookie(
            //     "isDigital",
            //     isDigital,
            //     300,
            //     this.$store.state.isGlobalMode
            // );
            // eslint-disable-next-line
            this.$modal.hide('log-in-modal');
            // console.log("--- login success");
            // let u = utils;
            // console.log(u.getCookie('userID'));
            // console.log(u.getCookie('token'));
            // eslint-disable-next-line no-prototype-builtins
            if (response.body.hasOwnProperty('msg')) {
              notify.info(response.body.msg);
            }
          },
          (error) => {
            console.log(error);
            if (Number(error.status) === 403) {
              notify.warning(error.body.msg || 'Hibás bejelentkezési adatok');
            } else {
              notify.error('Hiba a bejelentkezés során: ' + error.body.msg);
            }
          },
        )
        .finally(() => {
          this.$store.dispatch('fetchStartUp');
        });
    },
    createNewReservation (resData) {
      let reservationData = {
        subjectID: resData.subjectID,
        start: resData.start,
        email: this.user.email,
        name: this.user.name,
      };
      if (resData?.wantToPay) reservationData.wantToPay = true;
      if (resData?.withPartner) reservationData.withPartner = true;
      if (resData?.purchasedPassId) reservationData.purchasedPassId = resData.purchasedPassId;
      if (resData?.partner_available_id) reservationData.partner_available_id = resData.partner_available_id;
      if (resData.hasOwnProperty('wantToPayNegativeBalance'))
        reservationData.wantToPayNegativeBalance =
          resData.wantToPayNegativeBalance;
      if (resData?.timetableExtraOptions?.length > 0)
        reservationData.timetableExtraOptions = resData.timetableExtraOptions;
      reservationData.accepted_partner_apply_id = resData.accepted_partner_apply_id;

      console.log('--- create new reservation: ', reservationData);
      this.$http({
        url: this.isGlobalMode
          ? this.serverDomain + '/api/global/reserve'
          : this.serverDomain + '/api/guest/reserve',
        method: 'POST',
        params: {
          ...this.$store.getters.getAuthParams,
        },
        body: JSON.stringify({
          data: reservationData,
          domain: this.$store.state.currentClientDomain,
        }),
      }).then(
        (response) => {
          // check payment redirection
          if (response.body?.Method) {
            if (response.body?.Method === 'SUMUP_POS') { // method:GET
              let url = response.body.Url + '?'
                + Object.entries(response.body.Params).map(([key, value]) => key + '=' + encodeURIComponent(value)).join('&');
              console.log(url);
              window.location.href = url;
            } else if (response.body?.Method === 'SUMUP_CARD') {
              this.$modal.show('sum-up-payment-modal', {
                data: response.body.Params,
              })
            } else {
              notify.error(`Ismeretlen fizetési mód: "${response.body?.method}"`);
            }

          } else {
            console.log('--- create reservation success');
            notify.success(response.body.msg);
          }
        },
        (error) => {
          console.log(error);
          if (error?.body?.isRequiredAddress) {
            this.$modal.show('change-address-modal');
            notify.warning(
              'A foglaláshoz meg kell adnia a számlázási címet (Profil > Számlázási cím módosítása)',
            );
          } else if (error?.body?.isRequiredPhone) {
            this.$modal.show('change-phone-number-modal');
            notify.warning(
              'A jelenleg kiválasztott partnernél a foglaláshoz kötelező megadni a telefonszámot (Profil > Telefonszám módosítása',
            );
          } else {
            utils.httpError(error);
          }
        },
      );
    }, // createNewReservation
    pay (amount) {
      let paymentData = {
        // client: client,
        amount: amount,
      };

      console.log('--- pay: ', paymentData);

      this.$http({
        url: this.serverDomain + '/api/pay/start',
        method: 'POST',
        params: {
          ...this.$store.getters.getAuthParams,
        },
        body: JSON.stringify({
          data: paymentData,
          domain: this.$store.state.currentClientDomain,
        }),
      }).then(
        (response) => {
          // check borgun redirection
          if (response.body?.borgunPostBody && response.body?.borgunUrl) {
            this.$loading.show({
              container: this.fullPage ? null : this.$refs.formContainer,
              canCancel: false,
              onCancel: this.onCancel,
              loader: 'dots',
              height: '128',
              width: '128',
              color: '#ff9c00',
            });
            utils.redirectBorgunPayment(
              response.body.borgunUrl,
              response.body.borgunPostBody,
            );
            // console.log('--- borgunUrl:', response.body.borgunUrl)
            // console.log('--- borgunPostBody:', response.body.borgunPostBody)
          } else {
            console.log('--- payment failed: 38469');
            notify.warning('Sikertelen foglalás!');
          }
        },
        (error) => {
          console.log(error);
          if (error?.body?.isRequiredAddress) {
            this.$modal.show('change-address-modal');
            notify.warning(
              'A foglaláshoz meg kell adnia a számlázási címet (Profil > Számlázási cím módosítása)',
            );
          } else if (error?.body?.isRequiredPhone) {
            this.$modal.show('change-phone-number-modal');
            notify.warning(
              'A jelenleg kiválasztott partnernél a foglaláshoz kötelező megadni a telefonszámot (Profil > Telefonszám módosítása',
            );
          } else {
            utils.httpError(error);
          }
        },
      );
    },
    getUserReservations (isAllInOne) {
      console.log('--- getUserReservations ---');
      this.$http({
        url: this.serverDomain + '/api/global/reservations',
        method: 'GET',
        params: {
          ...this.$store.getters.getAuthParams,
          email: this.$store.state.user.email,
        },
      }).then(
        (response) => {
          let reservations = response.body;
          this.userReservations = reservations;
          this.$store.dispatch('setUserReservations', reservations);
          if (isAllInOne) {
            // eslint-disable-next-line
            this.$modal.show('profile-all-in-one-modal');
          } else {
            // eslint-disable-next-line
            this.$modal.show('reservation-modal');
          }
          console.log('--- get user reservations: ');
          console.log(reservations);
        },
        (error) => {
          utils.httpError(error);
        },
      );
    },
    forgottenPasswordRequest (data) {
      let email = data.email;
      this.$http({
        url: this.serverDomain + '/api/newpasswordemail',
        method: 'POST',
        params: { email: email },
      })
        .then(
          (response) => {
            console.log('--- new pwd sent');
            notify.success(response.body.msg);
          },
          (error) => {
            utils.httpError(error);
          },
        )
        .finally(() => {
          // eslint-disable-next-line
          this.$modal.hide('log-in-modal');
        });
    },
    insertFavoriteClient (domain) {
      this.$http({
        url: this.serverDomain + '/api/global/favorite',
        method: 'POST',
        params: {
          ...this.$store.getters.getAuthParams,
          favoriteDomain: domain,
        },
      }).then(
        (response) => {
          console.log('--- insert favorite client success');
          notify.success(response.body.msg);
          this.$store.dispatch('changeUserFavorite', domain);
        },
        (error) => {
          utils.httpError(error);
        },
      );
    },
    deleteFavoriteClient () {
      this.$http({
        url: this.serverDomain + '/api/global/favorite',
        method: 'DELETE',
        params: {
          ...this.$store.getters.getAuthParams,
        },
      }).then(
        (response) => {
          console.log('--- delete favorite client success');
          notify.success(response.body.msg);
          this.$store.dispatch('changeUserFavorite', null);
        },
        (error) => {
          utils.httpError(error);
        },
      );
    },
    changeFavoriteClient (domain) {
      this.$http({
        url: this.serverDomain + '/api/global/favorite',
        method: 'PUT',
        params: {
          ...this.$store.getters.getAuthParams,
          favoriteDomain: domain,
        },
      }).then(
        (response) => {
          console.log('--- update favorite client success ---');
          notify.success(response.body.msg);
          this.$store.dispatch('changeUserFavorite', domain);
          this.$store.dispatch('selectClient', domain);
        },
        (error) => {
          utils.httpError(error);
        },
      );
    },
    changeEmail (newEmail) {
      // alert('main view new email: ' + newEmail)
      console.log('change email to: ' + newEmail);
      this.$http({
        url: this.serverDomain + '/api/global/change_email_request',
        method: 'PUT',
        params: {
          ...this.$store.getters.getAuthParams,
          newEmail: newEmail,
        },
      }).then(
        (response) => {
          // eslint-disable-next-line
          this.$modal.hide('change-email-modal');
          notify.success(response.body.msg);
          console.log('email change request success');
          console.log(response);
        },
        (error) => {
          utils.httpError(error);
        },
      );
    },
    changeAddress (newAddressObj) {
      console.log('change address to: ' + newAddressObj);
      this.$http({
        url: this.serverDomain + '/api/global/change_address',
        method: 'PUT',
        params: {
          ...this.$store.getters.getAuthParams,
        },
        body: JSON.stringify(newAddressObj),
      }).then(
        (response) => {
          // eslint-disable-next-line
          this.$modal.hide('change-address-modal');
          notify.success(response.body.msg);
          this.$store.dispatch('setUserAddress', newAddressObj);
          console.log('change address success');
          console.log(response);
        },
        (error) => {
          utils.httpError(error);
        },
      );
    },
    fetchFreeClientsAtThisDatetime (data) {
      this.$http({
        url:
          this.serverDomain +
          '/api/global/get_clients_who_is_free_at_this_datetime',
        method: 'GET',
        params: {
          date: data.date,
          time: data.time,
          globalSubjectType: data.globalSubjectType,
        },
      }).then(
        (response) => {
          // eslint-disable-next-line
          console.log('--- fetchFreeClientsAtThisDatetime: ');
          console.log(response.body);
          this.$store.dispatch(
            'setFilteredFreeClients',
            response.body.availableClients,
          );
        },
        (error) => {
          utils.httpError(error);
        },
      );
    },
    openAllInOneModal () {
      this.fetchPasses(true);
    },
    isLoggedIn () {
      return this.$store.getters.isLoggedIn;
    },
  }, // methods
  computed: {
    user () {
      return this.$store.state.user
    },
    compTables () {
      let tables = this.tables;
      return tables;
    },
    isStartUpLoaded () {
      let globalSubjectTypes = this.$store.state.globalSubjectTypes;
      let isLoaded = false;

      if (globalSubjectTypes.length > 0) {
        if (this.isLoggedIn()) {
          // this.getUserReservations()
        }
        isLoaded = true;
      }
      // isLoaded = true
      return isLoaded;
    },
    isMobileDevice () {
      return this.$store.getters.isMobileDevice
    },
    isClientSelected () {
      return !!this.$store.state.currentClientDomain;
    },
    isUserReservationsLoaded () {
      return this.$store.state.userReservations !== null;
    },
    isGlobalMode () {
      return this.$store.state.isGlobalMode;
    },
    getCurrentTableDate () {
      return this.$store.state.currentTableDate;
    },
    isDemo () {
      return config.ENV == 'DEMO';
    },
  },
  watch: {
    isMountedTwo: function (val) {
      if (val.hasOwnProperty('filterForClients') && val.filterForCLients) {
        if (!this.isLoggedIn() && !utils.isTourDone('desktopLoggedOutTour')) {
          this.$tours['desktopLoggedOutTour'].start();
        }
      }
    },
  },
  /*mounted: function () {
    console.log('------- app mounted called -------');
  },*/
  sockets: {
    globalSideScheduleTablesUpdate: function (data) {
      let tables = data.tables;
      let client = data.client;
      let currentClient = this.$store.state.currentClientDomain;
      console.log('------------------- globalSideScheduleTablesUpdate -------------------');
      let isInterestingDate = false;
      for (let table of tables) {
        for (let day of table.days) {
          //console.log(this.$store.state.currentTableDate,  day.date);
          if (this.$store.state.currentTableDate ===  day.date) 
            isInterestingDate = true;
        }
      }

      if (isInterestingDate && (client === currentClient || client == this.$store.state.ownerDomain)) {
        let newTables;
        if (
          this.isLoggedIn() &&
          this.$store.state.user.hasOwnProperty('email') &&
          this.$store.state.user.hasOwnProperty('userType')
        ) {
          newTables = processTableStatus(
            this.$store.state.user.email,
            this.$store.state.user.userType,
            tables,
          );
        } else {
          newTables = processTableStatus(null, null, tables);
        }
        this.$store.commit('SET_TABLE', { tables: newTables });
        this.$store.dispatch('appendTableExtras'); // modules can subscribe to append extra data to state.tables
        console.log('--- socket globalSideScheduleTablesUpdate: ');
        console.log(tables);
      }
    },
    guestSideBalanceUpdate: function (data) {
      console.log('guestSideBalanceUpdate', data);
      // this.$set(this.user, 'balance', data.newBalance)
    },
    partnerAvailableList: function (data) {
      if (data.client === this.$store.state.currentClientDomain || data.client == this.$store.state.ownerDomain) {
        this.$store.dispatch('partnerFinder/socketAvailableList', data);
      }
    },
    partnerApplyList: function (data) {
      if (data.client === this.$store.state.currentClientDomain || data.client == this.$store.state.ownerDomain) {
        this.$store.dispatch('partnerFinder/socketApplyList', data);
      }
    },
  },
  components: {
    GuestSchedule,
    LoggedInMenu,
    LoggedOutMenu,
    SignUpModal,
    LogInModal,
    ProfileModal,
    ReservationModal,
    PassesModal,
    ClientMenu,
    ScheduleTableContainer,
    GoogleMarkedMap,
    FooterBox,
    HeaderBox,
    ProfileAllInOneModal,
    LocalScheduleTableContainer,
    LocalMenu,
    PayNegativeBalanceModal,
    PartnerFinderProfileModal,
  },
};

</script>

<style>
@font-face {
  font-family: "atf";
  /*noinspection CssUnknownTarget*/
  src: url("/static/fonts/AlternateGothicATF.woff") format("woff");
}

@font-face {
  font-family: "atf";
  /*noinspection CssUnknownTarget*/
  src: url("/static/fonts/AlternateGothicATF-Bold.woff") format("woff");
  font-weight: bold;
}

.schedule-container {
  height: 90vh;
}

.ui.vertical.menu {
  margin-top: 2rem;
}

/*
  img{
    margin: 10px 0 10px 0;
    width: 80%;
  }
*/
body {
  /*margin-top: 3rem;*/
  font-family: "Open Sans", sans-serif;
}

body > .logo {
  margin-top: 4rem;
}

.ui.modal {
  right: auto;
  bottom: auto;
  overflow: inherit;
}

.slider-km .vue-slider-tooltip:after {
  content: " km";
}

.foglaljpalyat-app {
  color: #0a0a0a;
}

.header-space {
  height: 45vw;
}

.header-space-mobile {
  height: 13vw;
}

.container {
  width: 100% !important;
  padding: 0 !important;
}

/* --- vue slider overwrite --- */
.vue-slider-component .vue-slider-dot {
  -webkit-border-radius: 0 !important;
  -moz-border-radius: 0 !important;
  border-radius: 0 !important;
  -webkit-box-shadow: none !important;
  -moz-box-shadow: none !important;
  box-shadow: none !important;
  background-color: #262c36 !important;
}

.vue-slider-component .vue-slider {
  -webkit-border-radius: 0 !important;
  -moz-border-radius: 0 !important;
  border-radius: 0 !important;
}

/* --- END vue slider overwrite END --- */

.schedule-table-place {
  max-height: 0;
  transition: max-height 1s;
}

.schedule-table-place.active {
  width: 100vw;
  max-height: 800px;
  transition: max-height 1s;
  padding: 0 5px;
  border-style: solid;
  border-color: #a0a9b6;
  border-width: 0 1px 1px 1px;
}

/* --- START overwrite semantic START --- */
.ui.icon.button {
  border-radius: 0 !important;
}

.ui.pagination.menu {
  border: none;
  border-radius: 0;
  box-shadow: none;
}

.ui.form > .field > .input,
.ui.form > .field > select {
  border-radius: 0;
}

.ui.segment {
  border-radius: 0;
  box-shadow: none;
}

input:focus,
select:focus,
textarea:focus,
button:focus {
  outline: none;
}

/* --- END overwrite semantic END --- */

#filterDatepicker {
  margin-top: 3px;
}

#filterDatepicker .mx-input {
  font-size: 100% !important;
  background: #a0a9b6 !important;
  color: #000 !important;
  /* line-height: 4.5 !important; */
  height: 3rem;
  border: 2px solid #b7bfc9 !important;
}

.swal-button {
  background-color: #2185d0;
  font-family: Lato, "Helvetica Neue", Arial, Helvetica, sans-serif;
}

.swal-button:not([disabled]):hover {
  background-color: #1678c2;
}

.swal-button--cancel {
  background-color: #e0e1e2;
}

.swal-button--cancel:not([disabled]):hover:hover {
  background-color: #cacbcd;
}

/* --------------------------- partnerfinder colors ----------------------------- */
.demo .menu {
  background: #5d96ffbf !important;
}


/* nem törlöm ki, mert tök jól néz ki, de notifi lett a vége...
.banner {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 2em;
    height: 6em;
    z-index: 1000;
    display: flex;
    align-items: stretch;
    justify-content: center;
}

.banner-inner {
background: #3c5272;
    color: white;
    display: flex;
    align-items: center;
    padding: 0 2em;
    font-size: 2em;
    border-radius: .2em;
    font-weight: 700;
    box-shadow: 3px 0 20px -5px #000000ba;
}*/

</style>
